import { render, staticRenderFns } from "./BannerText.vue?vue&type=template&id=6115209f"
import script from "./BannerText.vue?vue&type=script&lang=js"
export * from "./BannerText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports